module.exports = __webpack_public_path__ + "img/chrome.6a341ef5.png";